<template>
  <div>
    <table class="table table-striped">
      <thead>
      <tr>
        <th>{{ title }}</th>
        <th>Aktiivne</th>
        <th>Sisse</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(day, index) in days" :key="index">
        <td>
          {{ day }}
        </td>
        <td>
          <div class="form-check">
            <input class="form-check-input mx-0" type="checkbox" :checked="Boolean($store.getters.device(extra.serial)[getParameter('extruder_autostart_day_bool_', index)])" @change="setParameter(getParameter('extruder_autostart_day_bool_', index), 'checkbox', $event)" :id="'day-' + index">
            <label class="form-check-label" :for="'day-' + index">
            </label>
          </div>
        </td>
        <td>
          <div class="input-group">
            <input class="form-control" :value="$store.getters.device(extra.serial)[getParameter('extruder_autostart_hour_', index)]" @change="setParameter(getParameter('extruder_autostart_hour_', index), 'input', $event)" type="number" placeholder="tund" min="0" max="23" step="1">
            <span class="input-group-text" id="basic-addon1">:</span>
            <input class="form-control" :value="$store.getters.device(extra.serial)[getParameter('extruder_autostart_minute_', index)]" @change="setParameter(getParameter('extruder_autostart_minute_', index), 'input', $event)" type="number" placeholder="minut" min="0" max="55" step="5">
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ['title', 'extra'],
  data () {
    return {
      days: ['Esmaspäev', 'Teisipäev', 'Kolmapäev', 'Neljapäev', 'Reede', 'Laupäev', 'Pühapäev'],
      msg: {
        id: null,
        timeout: null
      }
    }
  },
  sockets: {
    controlDataStatus: function (data) {
      if (data.id === this.msg.id) {
        this.msg.id = null
        clearTimeout(this.msg.timeout)
        console.log('controlDataStatus:', data)
        if (data.success) {
          this.$swal.fire({ position: 'top-end', icon: 'success', title: 'Käsklus edastatud!', showConfirmButton: false, timer: 1500 })
        } else {
          this.$swal.fire({ position: 'top-end', icon: 'error', title: 'Tekkis viga!', text: data.message, showConfirmButton: false, timer: 2500 })
        }
      }
    }
  },
  methods: {
    setParameter (par, input, e) {
      this.msg.id = Date.now()
      console.log({ serial: this.extra.serial, id: this.msg.id, data: { [par]: parseInt((input === 'checkbox') ? Number(e.target.checked) : e.target.value) } })
      this.$socket.emit('controlData', { serial: this.extra.serial, id: this.msg.id, data: { [par]: parseInt((input === 'checkbox') ? Number(e.target.checked) : e.target.value) } })
      this.msg.timeout = setTimeout(this.msgTimeout, this.$store.state.msgTimeout)
    },
    msgTimeout () {
      this.msg.id = null
      this.$swal.fire({ position: 'top-end', icon: 'error', title: 'Käsklust ei edastatud', showConfirmButton: false, timer: 1500 }, this.$store.state.msgTimeout)
    },
    getParameter (par, day) {
      return par + (day + 1)
    }
  }
}
</script>
